/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TagsResponse
 */
export interface TagsResponse {
    /**
     * 
     * @type {string}
     * @memberof TagsResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TagsResponse
     */
    command: string;
}

export function TagsResponseFromJSON(json: any): TagsResponse {
    return TagsResponseFromJSONTyped(json, false);
}

export function TagsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'command': json['command'],
    };
}

export function TagsResponseToJSON(value?: TagsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'command': value.command,
    };
}

